/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Detail_Delete_Company_MessageInputs */

const en_admin_company_detail_delete_company_message = /** @type {(inputs: Admin_Company_Detail_Delete_Company_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this company? This action cannot be undone.`)
};

const de_admin_company_detail_delete_company_message = /** @type {(inputs: Admin_Company_Detail_Delete_Company_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie dieses Unternehmen wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete this company? This action cannot be undone." |
*
* @param {Admin_Company_Detail_Delete_Company_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_detail_delete_company_message = /** @type {((inputs?: Admin_Company_Detail_Delete_Company_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Detail_Delete_Company_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_detail_delete_company_message(inputs)
	return en_admin_company_detail_delete_company_message(inputs)
});